import { Box, Grid, GridProps, Skeleton, Typography } from '@mui/material'
import parse from 'html-react-parser'

import Button from '@/components/base/button'

import { WPLink } from '@/types'

export type AdvertisementCard = {
  title: string
  subtitle: string
  info: string
  text: string
  link: WPLink
}

export type AdvertisementCardProps = GridProps & Partial<AdvertisementCard & { skeleton: boolean }>

const AdvertisementCard = ({
  title,
  subtitle,
  info,
  text,
  link,
  skeleton,
  sx,
  ...props
}: AdvertisementCardProps) => {
  return (
    <Grid
      sx={{
        display: 'grid',
        position: 'relative',
        gap: 2,
        padding: 2,
        paddingTop: 4,
        alignItems: 'start',
        bgcolor: 'grey.100',
        borderRadius: (theme) => theme.shape.borderRadius8,
        ...sx
      }}
      {...props}
    >
      <Box sx={{ display: 'grid', gap: 2 }}>
        {title ? (
          <Typography variant="h6" color="text.secondaryContrastText" component="span">
            {skeleton ? <Skeleton width="70%" /> : title}
          </Typography>
        ) : null}

        {subtitle ? (
          <Typography
            variant="textLarge"
            color="primary.main"
            sx={{ '&>b': { fontWeight: '500' } }}
          >
            {skeleton ? <Skeleton width="40%" /> : parse(subtitle)}
          </Typography>
        ) : null}

        {info ? (
          <Typography
            variant="body1"
            color="text.secondaryContrastText"
            sx={{ '&>b': { fontWeight: '500' } }}
          >
            {skeleton ? <Skeleton width="30%" /> : parse(info)}
          </Typography>
        ) : null}

        {text ? (
          <Typography variant="textSmall" color="text.primary">
            {skeleton ? <Skeleton width="100%" height="7.2rem" /> : text}
          </Typography>
        ) : null}
      </Box>

      <Box sx={{ display: 'flex', marginTop: 'auto' }}>
        {skeleton ? (
          <Skeleton variant="rounded" width="14.8rem" height="4.8rem" sx={{ borderRadius: 999 }} />
        ) : (
          <Button href={link?.url} variant="outlined" icon="send-message">
            {link?.title}
          </Button>
        )}
      </Box>
    </Grid>
  )
}

export default AdvertisementCard
